module.exports = __webpack_public_path__ + "img/myguard_about_03.1a9fe4dc.png";